import losAngelesImage from "../assets/los-angeles.jpg";
import miamiImage from "../assets/miami.jpg";
import newYorkImage from "../assets/new-york.jpg";

export const defaultSearchDetails = {
  pickupLocation: "Miami International Airport, FL, United States",
  dropoffLocation:
    "Fort Lauderdale-Hollywood International Airport, FL, United States",
  pickupDate: "2026-04-23",
  pickupTime: "12:00",
  returnDate: "2026-04-30",
  returnTime: "12:00",
};

export const locationOptions = [
  "Miami International Airport, FL, United States",
  "Fort Lauderdale-Hollywood International Airport, FL, United States",
  "Orlando International Airport, FL, United States",
  "Tampa International Airport, FL, United States",
  "New York, NY, United States",
  "Los Angeles, CA, United States",
  "San Francisco, CA, United States",
  "Las Vegas Harry Reid International Airport, NV, United States",
  "Seattle-Tacoma International Airport, WA, United States",
];

export const timeOptions = [
  "08:00",
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00",
];

export const searchBenefits = [
  "Free cancellations on most bookings",
  "60,000+ locations",
  "Customer support in 30+ languages",
];

export const offerCards = [
  {
    title: "100+ Locations",
    description: "From Miami to Seattle - pickup and drop-off where you need.",
    image: newYorkImage,
    imageAlt: "New York rental location",
  },
  {
    title: "Lowest Guarantee",
    description: "Best pricing for your campaign with instant price match.",
    image: losAngelesImage,
    imageAlt: "Los Angeles savings destination",
  },
  {
    title: "24/7 Support",
    description:
      "Roadside assistance and customer service whenever you travel.",
    image: miamiImage,
    imageAlt: "Miami travel support destination",
  },
];
